import { Button } from '@piplapps/pipl-ui';
import { CSVLink } from 'react-csv';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './UploadUsersListContainer.module.less';
import AnalyticsHandler from '../../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../../Utils/AnalyticsHandler/AnalyticsEventNames';

const UploadCSVModal = (props) => {
  const exampleHeaders = ['Email', 'First name', 'Last name', 'Admin', 'Pipl Subscription'];
  const exampleData = 'upload.users@pipl.com,John,Smith,Yes,Yes';
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileInput, setFileInput] = useState(null);
  return (
    <div className={styles.modalContainer}>
      <div className={styles.header}>{gettext('Upload user list')}</div>
      <div className={styles.paragraph}>{gettext('Step 1 - Select and upload CSV')}</div>
      <div className={styles.text}>
        <AnalyticsHandler eventName={AnalyticsEventNames.UPLOAD_USERS_LIST_DOWNLOAD_TEMPLATE}>
          <CSVLink
            data={exampleData}
            headers={exampleHeaders}
            className={styles.downloadLink}
            filename="Users List Example.csv"
          >
            {gettext('Download CSV template. ')}
          </CSVLink>
        </AnalyticsHandler>
        <span>
          {gettext(
            'The order of the first 5 columns of the spreadsheet must be: Email, First name, Last name, Admin, Pipl Subscription.',
          )}
        </span>
      </div>
      <input
        type="file"
        id="file"
        ref={(input) => setFileInput(input)}
        style={{ display: 'none' }}
        onChange={(file) => {
          setSelectedFile(file.currentTarget.files[0]);
        }}
        key={selectedFile}
      />
      <AnalyticsHandler eventName={AnalyticsEventNames.UPLOAD_USERS_LIST_GET_STARTED}>
        <Button buttonClass="primary-blue" text={gettext('Select CSV file')} onClick={() => fileInput.click()} />
      </AnalyticsHandler>
      {selectedFile && (
        <div className={styles.uploadedCsvWrapper}>
          <span className={styles.uploadedCsv}>{selectedFile.name}</span>
          <a
            role="button"
            className={styles.removeLink}
            onClick={() => {
              setSelectedFile(null);
            }}
            tabIndex={0}
          >
            {' '}
            {gettext('remove')}
          </a>
        </div>
      )}
      <div className={styles.separator} />
      <div className={styles.paragraph}>{gettext('Step 2 - Validate the CSV information')}</div>
      <AnalyticsHandler eventName={AnalyticsEventNames.UPLOAD_USERS_LIST_VALIDATE_CSV}>
        <Button
          buttonClass="primary-blue"
          text={gettext('Validate CSV')}
          onClick={() => {
            const data = new FormData();
            data.append('file', selectedFile, selectedFile.name);
            props.validateCsvFile(data);
          }}
          disabled={!selectedFile}
        />
      </AnalyticsHandler>
    </div>
  );
};

UploadCSVModal.propTypes = {
  validateCsvFile: PropTypes.func,
};

export default UploadCSVModal;
